module.exports = __webpack_public_path__ + "static/media/size-34.e508202a.jpg";